<template>
  <div class="root">
    <div class="handle" @click="$emit('hide')">
      <a-icon type="right"/>
    </div>
    <div class="content">
      <div class="header">{{$t('calling.CollaborativeFile')}}</div>
      <div class="files" ref="files" v-if="fileList && fileList.length">
        <div v-for="file in fileList" :key="file.fid" class="file">
          <div class="file-icon">
            <FileEntityIcon :filename="file.name"/>
          </div>
          <div class="file-content">
            <div class="file-name" :title="file.name">{{getAttachName(file.name)}}</div>
            <div class="file-from">{{ $t('home.From') + ': ' + currentCoc.memberByUid[file.userId].nickName }}</div>
            <div class="file-updateTime">{{ $t('home.Time') + ': ' + format(file.addTime * 1000, 'yyyy-MM-dd HH:mm:ss') }}</div>
          </div>
          <Tooltip :title="$t('common.Download')" placement="top">
            <SvgIcon class-name="file-download" icon-class="download" @click.native="handleDownloadFile(file)" />
          </Tooltip>
        </div>
      </div>
      <div class="files" v-else style="text-align: center;">{{ $t('home.NoFiles') }}</div>
      <div class="buttons">
        <Button class="upload-btn" type="primary" shape="round" @click="handleUploadAttachFile">
          <SvgIcon icon-class="upload-full" class-name="icon-upload" />
          <span class="upload-text">{{$t('home.UploadAttachment')}}</span>
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import { Tooltip, Button } from 'ant-design-vue'
import { mapState, mapGetters, mapActions } from 'vuex'
import { FileEntityIcon } from '@/components/behavior/file-entiry/index'
import { download } from '@/utils/download'
import { uploadFile } from '@/utils/upload'
import { fileSelector } from '@/utils/file-selector'
import { CONFERENCE_STATE } from '@/utils/constant'
import { format } from 'date-fns'
import { queryAttachFiles } from '@/api/coc'

export default {
  name: 'FileManager',
  components: { FileEntityIcon, Tooltip, Button },
  computed: {
    ...mapGetters(['localUser']),
    ...mapGetters('coc', ['currentCoc']),
    ...mapState('coc', ['currentCocId', 'notReadFileCount']),
  },
  data () {
    return {
      fileList: []
    }
  },
  watch: {
    notReadFileCount (newValue, oldValue) {
      this.$nextTick(() => {
        this.queryAttachFiles()
      })
    },
    fileList: {
      handler(){
        const _this = this
        _this.$nextTick(() => {
          const filesDom = _this.$refs.files
          if (filesDom) {
            const moveHeight = filesDom.scrollHeight - filesDom.clientHeight
            if (typeof moveHeight === 'number') {
              filesDom.scrollTop = moveHeight
            }
          }
        })
      },
      deep: true
    }
  },
  created () {
    this.queryAttachFiles()
  },
  methods: {
    ...mapActions('coc', ['addAttachFiles']),
    format,
    queryAttachFiles () {
      queryAttachFiles(this.currentCocId).then(res => {
        this.fileList = res.files
      })
    },
    getAttachName(text) {
      const lastDotIndex = text.lastIndexOf('.')
      if (lastDotIndex > -1) {
        return text.substring(0, lastDotIndex)
      }
      return text
    },
    handleDownloadFile(file) {
      let url = file.url
      if (url.indexOf('/') !== 0) {
        url = '/' + url
      }
      download(url, file.name)
    },
    handleUploadAttachFile() {
      fileSelector(async (files) => {
        if (files.length === 1) {
          const file = files.item(0)
          if (file.size > 50 * 1024 * 1024) {
            this.$confirm({
              content: this.$t('home.More50MFile'),
              width: '460px',
              centered: true,
              class: 'confirm-exit',
              closable: true,
              cancelText: this.$t('common.Cancel'),
              okText: this.$t('common.Ok'),
            })
          } else {
            const formData = new FormData()
            formData.append('file', file)

            const fileName = file.name

            const conferenceId = this.currentCocId

            if (conferenceId) {
              const cocDetail = this.currentCoc

              if (cocDetail && cocDetail.confererceState === CONFERENCE_STATE.IN_PROGRESS && cocDetail.roomId) {
                formData.append('channelId',)
              }
            }
            const url = await uploadFile(formData)
            this.addAttachFiles({
              conferenceId,
              files: [{ url, name: fileName, type: 0 }],
              notify: true
            }).then(() => {
              this.queryAttachFiles()
              const params = {
                content: { type: 'FILE_MSG', text: url, filename: fileName, filesize: file.size },
                conferenceId: this.$router.currentRoute.params.conferenceId
              }
              this.$store.dispatch('localUserSticker', params)
            })
          }
        }
      })
    },
  }
}
</script>

<style scoped lang="less">
@import url(~@/styles/font.less);
@import url(~@/styles/button.less);

.upload-btn {
  padding: 8px 16px;
  height: 40px;
  & > .icon-upload {
    margin-right: 8px;
  }
  &.ant-btn{
    padding: 9px 72px 10px 71px;
  }
  &.ant-btn-primary {
    .medium-font(16);
    .primary-btn-mixins();
  }
}

.root {
  display: flex;
  align-items: center;
  height: 100%;

  .handle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 64px;
    border-radius: 10px 0 0 10px;
    background-color: rgba(#0A0F1A, 20%);
    cursor: pointer;

    .anticon {
      color: white;
    }
    &:hover {
      background-color: rgba(#0A0F1A, 40%);
    }
  }

  .content {
    background-color: white;
    height: 100%;
    display: flex;
    flex-direction: column;

    .header {
      flex: none;
      font-size: 18px;
      font-weight: 600;
      word-break: keep-all;
      height: 56px;
      // width: 383px;
      width: 400px;
      text-align: center;
      line-height: 56px;
    }

    .files {
      margin-top: 24px;
      flex-grow: 1;
      overflow-y: auto;
      background-color: #ffffff;
      .file {
        display: grid;
        grid-template-columns: 46px 269px 20px;
        grid-template-rows: 62px;

        position: relative;
        padding: 11px 25px 9px 24px;
        margin-bottom: 4px;
        &:hover {
          background-color: #D8D8D8;
        }
        &-content{
          width: 222px;
        }
        &-name{
          display: -webkit-box;
          word-break: break-all;
          text-overflow:ellipsis;
          overflow: hidden;
          white-space: pre-line;
          -webkit-box-orient: vertical;
          -webkit-line-clamp:1;

          height: 22px;
          font-size: 16px;
          font-weight: 500;
          color: #333333;
          line-height: 22px;
        }
        &-download{
          height: 20px;
          width: 20px;
          font-size: 20px;
          cursor: pointer;
          color: #236CFF;
          margin-top: 21px;
        }
        &-from,&-updateTime{
          height: 20px;
          font-size: 14px;
          font-weight: 400;
          color: #999B9F;
          line-height: 20px;
        }
        &-icon {
          color: #000;
          height: 32px;
          line-height: 32px;
          margin-top: 4px;

            & > .file-entity-icon {
            width: 30px;
            height: 32px;
            vertical-align: top;
          }
        }
      }
    }

    .buttons {
      flex: none;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 97px;
      flex-grow: 0;
      background: rgba(white, 0.85);

      // ::v-deep .basic-btn-group > button {
      //   margin-right: 20px;
      //   padding: 0 18px;

      //   .svg-icon {
      //     margin-right: 8px;
      //   }

      //   &:last-child {
      //     margin-right: 0;
      //   }
      // }
    }

    .header, .buttons {
      border-bottom: 1px solid #edeff2;
      border-top: 1px solid #edeff2;
      box-shadow: 0 -10px 30px 0 rgba(#5984db, 10%);

    }
  }
}
</style>
